/* eslint-disable import/no-unresolved */
//no-unresolved issue: https://github.com/nolimits4web/swiper/issues/5058

import { Swiper, SwiperSlide, SwiperProps } from 'swiper/react';
import { Navigation } from 'swiper';
import styled from 'styled-components';

import 'swiper/css';
import 'swiper/css/navigation';
import { useDevice } from '@contexts/device';

const Wrapper = styled.div`
  .swiper-button-next,
  .swiper-button-prev {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 50px;
    color: white;
    width: 50px;
    height: 50px;
    border: 2px solid ${({ theme }) => theme.palette.white};
    ::after {
      font-size: 32px;
    }
    :hover {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }

  .swiper-button-disabled {
    opacity: 0.35;
    cursor: unset;
    pointer-events: unset !important;
  }
`;

const Carousel = (props: SwiperProps) => {
  const { isDesktop } = useDevice();

  return (
    <Wrapper>
      <Swiper
        spaceBetween={5}
        autoplay={false}
        loop={false}
        slidesPerView={1.2}
        navigation={isDesktop}
        modules={[Navigation]}
        breakpoints={{
          720: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          510: {
            slidesPerView: 2.2,
            spaceBetween: 10,
          },
          450: {
            slidesPerView: 1.6,
            spaceBetween: 10,
          },
        }}
        {...props}
      />
    </Wrapper>
  );
};

export { SwiperSlide };
export default Carousel;
